import type { CoinView } from './model';

export function feedCollections({
  live,
  liveHistory,
  game,
  feed,
  selectedFeed,
}: {
  live: CoinView[];
  liveHistory: CoinView[];
  game: CoinView[];
  feed: 'live' | 'game';
  selectedFeed: 'live' | 'game';
}) {
  return {
    arena: feed === 'game' ? game : live,
    // Use the same complete personal history on both screens and mobile.
    arenaSidebar: feed === 'game' ? game : liveHistory,
    explore: selectedFeed === 'game' ? game : liveHistory,
    // Points activity can open a round from either mode, independently of the
    // header selection. Filter the visible lists, not the shared detail lookup.
    details: [...liveHistory, ...game],
  };
}
